import { getHeaders } from '../utils';

export const APIGetAccessCredentials = async (entity_type, entity_id, username, password) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };

    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/access/1.0/credentials/${entity_type}/id/${entity_id}?user=${username}&pw=${password}`, requestOptions);
    const responseText = await response.json();

    if (responseText) {
      return responseText.data;
    } else {
      return null;
    }

  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIPostAccessCredentials = async (entity_id, entity_type, username, password) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        entity_id: entity_id,
        entity_type: entity_type,
        username: username,
        password: password,
      }),
      redirect: 'follow',
    };
    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/access/1.0/credentials`, requestOptions);
    const responseText = await response.json();
    if (responseText) {
      return responseText.data;
    } else {
      return null;
    }
  }
  catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIDeleteAccessCredentials = async (id) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'DELETE',
      headers: headers,
      redirect: 'follow',
    };
    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/access/1.0/credentials/${id}`, requestOptions);
    const responseText = await response.json();
    if (responseText) {
      return responseText.data;
    } else {
      return null;
    }
  }
  catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIDeleteAccessId = async (id) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'DELETE',
      headers: headers,
      redirect: 'follow',
    };
    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/access/1.0/id/${id}`, requestOptions);
    const responseText = await response.json();
    if (responseText) {
      return responseText.data;
    } else {
      return null;
    }
  }
  catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIGetAccessId = async (accessId) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };
    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/access/1.0/id/${accessId}`, requestOptions);
    const responseText = await response.json();
    if (responseText) {
      return responseText.data;
    } else {
      return null;
    }
  }
  catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIPostAccessId = async (entity_id, entity_type) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        entity_id: entity_id,
        entity_type: entity_type,
      }),
      redirect: 'follow',
    };
    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/access/1.0/id`, requestOptions);
    const responseText = await response.json();
    if (responseText) {
      return responseText.data;
    } else {
      return null;
    }
  }
  catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIGetAllAccess = async (entity_id, entity_type) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'GET',
      headers: headers,
      redirect: 'follow',
    };
    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/access/1.0/all/${entity_type}/id/${entity_id}`, requestOptions);
    const responseText = await response.json();
    if (responseText) {
      return responseText.data;
    } else {
      return null;
    }
  }
  catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIPostAccessAccount = async (entity_id, entity_type, email) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        entity_id: entity_id,
        entity_type: entity_type,
        email: email,
        permissions: {
          read: true,
          write: false,
        }
      }),
      redirect: 'follow',
    };
    const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/access/1.0/account`, requestOptions);
    const responseText = await response.json();
    if (responseText) {
      return responseText.data;
    } else {
      return null;
    }
  }
  catch (error) {
    console.error('Error:', error);
    throw error;
  }
}

export const APIDeleteAccessAccount = async (id) => {
  try {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const requestOptions = {
      method: 'DELETE',
      headers: headers,
      redirect: 'follow',
    };
    // Use template literals to construct the URL
    const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
    const response = await fetch(`${apiUrl}/access/1.0/account/${id}`, requestOptions);
    const responseText = await response.json();
    if (responseText) {
      return responseText.data;
    } else {
      return null;
    }
  }
  catch (error) {
    console.error('Error:', error);
    throw error;
  }
}